import React from "react"
import { Link } from "gatsby"
import { Container, Breadcrumb, BreadcrumbItem } from "reactstrap"
import Layout from "./../components/layout"
import SEO from "./../components/seo"
import "../style/products.css"

function Analysis() {
  return (
    <Layout>
      <SEO />
      <Breadcrumb className="breadCrumb">
        <BreadcrumbItem>
          <Link className="breadCrumbLinks" to="/">
            Home
          </Link>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <Link className="breadCrumbLinks" to="/products">
            Products
          </Link>
        </BreadcrumbItem>
        <BreadcrumbItem active>Data Analysis</BreadcrumbItem>
      </Breadcrumb>
      <Container>
        <h1>Data Analysis</h1>
      </Container>
    </Layout>
  )
}

export default Analysis
